export default "/humidity.c7277f80-14d2fd.svg";